import React, {useState} from 'react';
import dateFormat from 'dateformat';

import * as S from './SearchBlockUI.styles';
import GoSafeCardBlock from '../../../../../shared/pages/SmartEngage/containers/GoSafeCardBlock';
import useSearchWidgetUI from '../../../../../shared/hooks/useSearchWidgetUI';
import PaxWidget from './../PaxWidget/PaxWidget';
import CalendarBlock from '../CalendarBlock/CalendarBlock';
import {countryTextMap} from '../../../../../shared/config/app-config';
import HappySearchIcon from '@stencil/icons/src/HappySearchIcon/HappySearchIcon';
import {defaultTheme} from '@stencil/build-theme';

import HomePageAutosuggest from './../../SRP/Autosuggests/HomePageAutosuggest/HomePageAutosuggest';
import {convertRoomStringToReadable} from '../../../../../shared/utils/room-string-utils';

const SearchBlockUI = ({
  updateQueryCaller,
  autosuggestHandler,
  country,
  checkin,
  checkout,
  partner,
  roomString,
  onSearchClick,
  destination,
  eventMiddlewareForFE,
  homePageClicksGAHandler,
  isHomePageAutosuggestEmpty,
}) => {
  const [displayOverlay, setDisplayOverlay] = useState(false);

  const {
    calendarBlockRef,
    paxWidgetBlockRef,
    isPaxWidgetVisible,
    calendarMode,
    closeCalendar,
    setCalendarMode,
    togglePaxWidget,
  } = useSearchWidgetUI();

  const numberOfNights = Math.floor(
    (checkout.date.getTime() - checkin.date.getTime()) / (1000 * 3600 * 24),
  );

  const numberOfNightsText = `${numberOfNights} Night${numberOfNights > 1 ? 's' : ''}`;

  const isCalendarVisible = calendarMode !== '';

  return (
    <S.AutoSuggestOuterWrap>
      {((displayOverlay || isCalendarVisible || isPaxWidgetVisible) && <S.PageOverlay />) || null}
      <S.AutoSuggestInnerWrap>
        <S.HotelTypeSelectWrap>
          {/* should refactor following into a map and run on top of countryTextMap */}
          <S.RadioButtonWrap
            onClick={() => {
              updateQueryCaller({country: countryTextMap.india.key});
              homePageClicksGAHandler('hotelTopNavigation', countryTextMap.india.key);
            }}
          >
            <S.RadioButton
              type="radio"
              name="CountryType"
              checked={country === countryTextMap.india.key}
            />
            <S.RadioButtonLabel />
            <S.RadioText>{countryTextMap.india.value}</S.RadioText>
          </S.RadioButtonWrap>
          <S.RadioButtonWrap
            onClick={eventMiddlewareForFE({
              onClick: () => {
                updateQueryCaller({country: countryTextMap.international.key});
                homePageClicksGAHandler('hotelTopNavigation', countryTextMap.international.key);
              },
            })}
          >
            <S.RadioButton
              type="radio"
              name="CountryType"
              checked={country && country !== countryTextMap.india.key}
            />
            <S.RadioButtonLabel />
            <S.RadioText>{countryTextMap.international.value}</S.RadioText>
          </S.RadioButtonWrap>
        </S.HotelTypeSelectWrap>

        <S.CitySearchWrap>
          <S.AutoSuggestLabelText>Where</S.AutoSuggestLabelText>

          <S.SearchInputWrap
            data-something={displayOverlay ? 'true' : 'false'}
            isactive={displayOverlay ? 'true' : 'false'}
          >
            {/* <S.SearchIconWrap /> */}
            <HappySearchIcon
              fill={defaultTheme.colors.downriver.medium}
              width="1.6rem"
              height="1.6rem"
            />
            <HomePageAutosuggest
              initialInputValue={destination.n}
              onItemSelection={changes => {
                autosuggestHandler(changes);
                homePageClicksGAHandler('locationType', changes?.selectedItem?.t);
              }}
              toggleOverlay={setDisplayOverlay}
              displayOverlay={displayOverlay}
              partner={partner}
              isHomePageAutosuggestEmpty={isHomePageAutosuggestEmpty}
              onClick={eventMiddlewareForFE({
                onClick: () => {
                  homePageClicksGAHandler('locationClicked');
                },
              })}
            />
          </S.SearchInputWrap>
        </S.CitySearchWrap>

        <S.CitySearchWrap>
          <S.SearchCheckingDateWrap>
            <S.CheckInCheckOutWrap>
              <div
                onClick={() => {
                  setCalendarMode('checkin');
                  homePageClicksGAHandler('calendarClicked');

                  if (isPaxWidgetVisible) togglePaxWidget(false);
                }}
                data-testid="openCheckinCalendar"
              >
                <S.AutoSuggestCheckText>Check-in</S.AutoSuggestCheckText>
                <S.CheckInDateWrapDiv>
                  {dateFormat(checkin.date, 'mediumDate')}
                </S.CheckInDateWrapDiv>
              </div>
              {(calendarMode === 'checkin' && (
                <CalendarBlock
                  ref={calendarBlockRef}
                  isCheckinMode={calendarMode === 'checkin'}
                  isCheckoutMode={false}
                  onSelection={() => {
                    setCalendarMode('checkout');
                  }}
                  updateQueryCaller={updateQueryCaller}
                  checkin={checkin}
                  checkout={checkout}
                  gaHandler={homePageClicksGAHandler}
                />
              )) ||
                null}
            </S.CheckInCheckOutWrap>
            <S.VerticalLine></S.VerticalLine>
            <S.NightCountWrap>{numberOfNightsText}</S.NightCountWrap>
            <S.CheckInCheckOutWrap>
              <div
                onClick={() => {
                  setCalendarMode('checkout');
                  homePageClicksGAHandler('calendarClicked');

                  if (isPaxWidgetVisible) togglePaxWidget(false);
                }}
                data-testid="openCheckoutCalendar"
              >
                <S.AutoSuggestCheckText>Check-out</S.AutoSuggestCheckText>
                <S.CheckInDateWrapDiv>
                  {dateFormat(checkout.date, 'mediumDate')}
                </S.CheckInDateWrapDiv>
              </div>
              {(calendarMode === 'checkout' && (
                <CalendarBlock
                  ref={calendarBlockRef}
                  isCheckinMode={false}
                  isCheckoutMode={calendarMode === 'checkout'}
                  onSelection={closeCalendar}
                  updateQueryCaller={updateQueryCaller}
                  checkin={checkin}
                  checkout={checkout}
                  gaHandler={homePageClicksGAHandler}
                />
              )) ||
                null}
            </S.CheckInCheckOutWrap>
          </S.SearchCheckingDateWrap>
        </S.CitySearchWrap>

        <S.PaxCountWrap
          onClick={() => {
            if (isCalendarVisible) closeCalendar();

            if (!isPaxWidgetVisible) {
              togglePaxWidget(true);
            }
          }}
        >
          <S.AutoSuggestLabelText>Guests & Rooms</S.AutoSuggestLabelText>
          <S.SearchInputWrap>
            <S.CitySearchInput type="text" value={convertRoomStringToReadable(roomString)} />
            {(isPaxWidgetVisible && (
              <PaxWidget
                ref={paxWidgetBlockRef}
                togglePaxWidget={togglePaxWidget}
                updateQueryCaller={updateQueryCaller}
                roomString={roomString}
                gaHandler={homePageClicksGAHandler}
                updateSearch={() => {}}
              />
            )) ||
              null}
          </S.SearchInputWrap>
        </S.PaxCountWrap>

        <GoSafeCardBlock ContainerWrapper={S.GoSafeSearchBlockContainerWrap} />

        <S.SearchButtonAutoSuggest onClick={onSearchClick} data-testid="searchHotelBtn">
          Search Hotels
        </S.SearchButtonAutoSuggest>
      </S.AutoSuggestInnerWrap>
    </S.AutoSuggestOuterWrap>
  );
};

export default React.memo(SearchBlockUI);
